"use client";

import {
  Field,
  RichTextField,
  Text,
  withDatasourceCheck,
} from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { ComponentProps } from "@repo/sitecore-lib/component-props";
import { TYPOGRAPHY_HEADING3_BOLD } from "@/theme/topshop/typography/typography-constants";
import HtmlContent from "../../../html-content/html-content";
import styles from "./highlight-block.module.css";

type HighlightBlockProps = ComponentProps & {
  fields: {
    title: Field<string>;
    bodyCopy: RichTextField;
  };
};

const HighlightBlock = ({
  fields: { title, bodyCopy },
  rendering,
  params,
}: HighlightBlockProps) => {
  return (
    <div className={styles.faqContentBox} data-testid="highlight-block">
      <Text
        tag="h2"
        field={title}
        className={clsx(styles.contentTitle, TYPOGRAPHY_HEADING3_BOLD)}
      />
      <div className={styles.contentBody}>
        <HtmlContent
          fields={{ Text: bodyCopy as RichTextField }}
          rendering={rendering}
          params={params}
        />
      </div>
    </div>
  );
};

export default withDatasourceCheck()<HighlightBlockProps>(HighlightBlock);
